import { render, staticRenderFns } from "./ReleaseNoteSummary.vue?vue&type=template&id=5451812c&scoped=true&"
import script from "./ReleaseNoteSummary.vue?vue&type=script&lang=js&"
export * from "./ReleaseNoteSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNoteSummary.vue?vue&type=style&index=0&id=5451812c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451812c",
  null
  
)

export default component.exports